import { IconButton, Typography } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useStyles } from './MessagePreview.styles';
import { convertToFormatDateTime } from '../../../utils/dateFunctionUtils';
import { FolderMessageContent, Priority } from '../../../models/communication.types';
import PriorityBox from '../PriorityBox/PriorityBox.component';
import MessageFlag from '../MessageFlag.component';
import DropdownMenu, { MenuItemWithImage } from '../../DropdownMenu/DropdownMenu.component';
import MessageParticipantLabel from '../MessagesList/MessageParticipantLabel.component';
import MessagePreviewBodyFooter from '../MessagePreviewBodyFooter/MessagePreviewBodyFooter.component';
import {
  foldersWithSeparatedParticipant,
  foldersWithSpecialCaseDataDisplaying,
} from '../../../models/communication.types';

import { Folder } from '../../../models/communication.types';
import { getAssessment, getSpecialCaseCardRedirectorUrl } from '../../../utils/routerUrls';
import OutlinedButton from '../../buttons/OutlinedButton.component';
import { useHistory } from 'react-router-dom';

interface MessageContentDisplayProps {
  loadedMessageContent: FolderMessageContent;
  actionsHidden: string | null;
  activeFolder: Folder;
  actionMenuRef: React.RefObject<SVGSVGElement>;
  actionMenuAnchor: SVGSVGElement | undefined;
  setActionMenuAnchor: (anchor: SVGSVGElement | undefined) => void;
  actionItems: MenuItemWithImage[];
}

const MessageContentDisplay: React.FC<MessageContentDisplayProps> = ({
  loadedMessageContent,
  actionsHidden,
  activeFolder,
  actionMenuRef,
  actionMenuAnchor,
  setActionMenuAnchor,
  actionItems,
}) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div
      className={classes.messageContent}
      style={{
        height: actionsHidden ? '100%' : 'calc(100% - 45px)',
      }}
    >
      <div className={classes.subjectContener}>
        <Typography className={classes.subject}>{loadedMessageContent.subject}</Typography>
      </div>
      {loadedMessageContent.priorityId !== Priority.Low && (
        <div style={{ padding: '0 15px 0 15px', marginBottom: '-15px' }}>
          <PriorityBox priority={loadedMessageContent.priorityId} allreadySent={true} />
        </div>
      )}
      <div className={classes.messageContener}>
        <div className={classes.messageHeader}>
          <div className={classes.messageHead}>
            <div style={{ flexGrow: 2 }}>
              <Typography className={classes.sender}>
                <MessageParticipantLabel message={loadedMessageContent} isMessageContentView={true} />
              </Typography>
              <div style={{ maxHeight: '200px', overflow: 'auto' }}>
                <Typography className={classes.recipient}>
                  <MessageParticipantLabel message={loadedMessageContent} revert={true} isMessageContentView={true} />
                </Typography>
              </div>
            </div>
            <div>
              <Typography className={classes.sentDate}>
                {convertToFormatDateTime(loadedMessageContent.sentDate)}
              </Typography>
            </div>
            {loadedMessageContent.flag !== null && (
              <div style={{ margin: '0 -3px 0 5px' }}>
                <MessageFlag flagId={loadedMessageContent.flag} />
              </div>
            )}
            {!actionsHidden && (
              <div>
                <IconButton
                  disableRipple
                  aria-label="Akcje"
                  size="small"
                  onClick={() => setActionMenuAnchor(actionMenuRef.current ?? undefined)}
                >
                  <MoreVertIcon
                    ref={actionMenuRef}
                    className={classes.actionIcon}
                    aria-controls="action-menu"
                    aria-haspopup="true"
                    aria-hidden="false"
                  />
                </IconButton>
                <DropdownMenu
                  anchorEl={actionMenuAnchor}
                  setAnchorEl={setActionMenuAnchor}
                  menuItemsWithImages={actionItems}
                  onClick={(text, item) => {
                    item && item.onClick && item.onClick();
                    setActionMenuAnchor(undefined);
                  }}
                  onClose={() => setActionMenuAnchor(undefined)}
                  placement="left-start"
                />
              </div>
            )}
          </div>
            {foldersWithSeparatedParticipant.includes(activeFolder) &&
              loadedMessageContent.examTaskGroupSolutionScoreId &&
              loadedMessageContent.assessmentSession !== '' && (
                <div className={classes.buttonContainer}>
                  <OutlinedButton
                    className={classes.goToCardButton}
                    size="small"
                    onClick={() =>
                      history.push(
                        getAssessment(
                          loadedMessageContent.examTaskGroupSolutionScoreId!,
                          loadedMessageContent.assessmentSession,
                        ),
                      )
                    }
                  >
                    Wyświetl pracę
                  </OutlinedButton>
                </div>
              )}

            {foldersWithSpecialCaseDataDisplaying.includes(activeFolder) &&
              loadedMessageContent.examTaskGroupSolutionScoreId &&
              loadedMessageContent.taskSolutionSheetId && 
              loadedMessageContent.assessmentSession !== '' &&
              (
                <div className={classes.specialCaseRow}>
                  <div style={{ flexGrow: 2 }}>
                    <Typography className={classes.specialCaseType}>
                      <span className={classes.specialCaseTypeLabel}>Rodzaj:</span>{' '}
                      {loadedMessageContent.specialCaseDefinitionTitle}
                    </Typography>
                  </div>
                  <div>
                    <OutlinedButton
                      className={classes.goToCardButton}
                      size="small"
                      onClick={() =>
                        history.push(
                          getSpecialCaseCardRedirectorUrl(
                            loadedMessageContent.examTaskGroupSolutionScoreId!,
                            loadedMessageContent.taskSolutionSheetId!,
                            loadedMessageContent.assessmentSession,
                          ),
                        )
                      }
                    >
                      Wyświetl pracę
                    </OutlinedButton>
                  </div>
                </div>
              )}
        </div>

        <div style={{ height: '100%', overflow: 'auto', whiteSpace: 'pre-wrap' }}>
          <Typography className={classes.content}>{loadedMessageContent.body}</Typography>
        </div>
        {loadedMessageContent && <MessagePreviewBodyFooter messageContent={loadedMessageContent} />}
      </div>
    </div>
  );
};

export default MessageContentDisplay;
